import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import ProjectFacts from "@/components/ProjectFacts";
import SiteLocation from "@/components/SiteLocation";
import WhySection from "@/components/WhySection";
import SiteAndPanels from "@/components/SiteAndPanels";
import IndicativeLayout from "@/components/IndicativeLayout";
import InformationGrid from "@/components/InformationGrid";
import ConstructionTimeline from "@/components/ConstructionTimeline";
import PlanningProcess from "@/components/PlanningProcess";
import AboutDeveloper from "@/components/AboutDeveloper";
import BookingSection from "@/components/BookingSection";
import FeedbackSection from "@/components/FeedbackSection";
import FaqSection from "@/components/FaqSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <div className="bg-[#F9F8F6] text-[#2A2B2A]" data-testid="home-page">
      <Navigation />
      <main>
        <Hero />
        <ProjectFacts />
        <SiteLocation />
        <WhySection />
        <SiteAndPanels />
        <IndicativeLayout />
        <InformationGrid />
        <ConstructionTimeline />
        <PlanningProcess />
        <AboutDeveloper />
        <BookingSection />
        <FeedbackSection />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
